import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormControl, ValidatorFn, AbstractControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';

import { BaseRepository } from '@interfaces/base-repository';

@Component({
    selector: 'app-autocomplete-filter',
    templateUrl: './autocomplete-filter.component.html',
    styleUrls: ['./autocomplete-filter.component.scss']
})
export class AutocompleteFilterComponent<T extends BaseRepository> implements OnInit {
    @Input() list: T[];
    @Input() control: UntypedFormControl;
    @Input() label: string;
    @Input() errorMsg: string;
    @Input() valueWanted: string;
    @Input() clearFilter: boolean;



    filteredList: Observable<T[]>;

    constructor() { }

    ngOnInit() {
        this.setfilters();
    }

    displayFn(object: T): string | undefined {
        return object ? object.display : null;
    }

    private setfilters(): void {
        const validators = [this.forbiddenTypeValidator('string')];

        if(this.control.validator) {
            validators.push(this.control.validator);
        }

        this.control.setValidators(validators);


        this.filteredList = this.control.valueChanges
            .pipe(
                startWith(''),
                map((value: string | T) => typeof value === 'string' ? value : value?.display),
                map((value: string) => value ? this.filter(value) : this.list.slice())
            );


    }

    private filter(value: string): T[] {
        const filterValue = value.toLowerCase();
        return this.list.filter(item => item.doesInclude(filterValue));
    }

    private forbiddenTypeValidator(forbiddenType: string): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const forbidden = control.value !== '' && typeof control.value === forbiddenType;
            return forbidden ? { forbiddenType: { value: control.value } } : null;
        };
    }
}
